export const VNWEBACCOUNT_SET_SEATS = 'VNWEBACCOUNT_SET_SEATS'
export const VNWEBACCOUNT_SET_PASS = 'VNWEBACCOUNT_SET_PASS'
export const VNWEBACCOUNT_SET_ORDER_HISTORY = 'VNWEBACCOUNT_SET_ORDER_HISTORY'
export const VNWEBACCOUNT_SET_EXPERIENCE_ORDER_HISTORY = 'VNWEBACCOUNT_SET_EXPERIENCE_ORDER_HISTORY'
export const VNWEBACCOUNT_SET_BRAINTREE_CLIENT_TOKEN = 'VNWEBACCOUNT_SET_BRAINTREE_CLIENT_TOKEN'
export const VNWEBACCOUNT_SET_SHIFT4_SERVER_AND_ACCESS_BLOCK = 'VNWEBACCOUNT_SET_SHIFT4_SERVER_AND_ACCESS_BLOCK'
export const VNWEBACCOUNT_RESET_SHIFT4_SERVER_AND_ACCESS_BLOCK = 'VNWEBACCOUNT_RESET_SHIFT4_SERVER_AND_ACCESS_BLOCK'
export const VNWEBACCOUNT_SET_SHIFT4_TOKENIZATION = 'VNWEBACCOUNT_SET_SHIFT4_TOKENIZATION'
export const VNWEBACCOUNT_SET_VAULTED_CARDS = 'VNWEBACCOUNT_SET_VAULTED_CARDS'
